
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <div
        class="
          notification-info
          border-raduis-md
          bg-white
          box-shadow-xl-dark
          mb-4
          p-4
        "
      >
        <div class="title d-flex align-items-center mb-4">
          <b-skeleton type="avatar"></b-skeleton>
          <b-skeleton
            class="ml-2"
            variant="light"
            height="30px"
            width="75%"
          ></b-skeleton>
        </div>
        <b-skeleton
          v-for="n in 16"
          :key="n"
          variant="light"
          class="mb-2"
          height="15px"
          width="100%"
        ></b-skeleton>
      </div>
    </template>

    <div
      class="
        notification-info
        border-raduis-md
        bg-white
        box-shadow-xl-dark
        mb-4
        p-4
      "
    >
      <div class="title pb-3 d-flex justify-content-between align-items-center">
        <div  class="text-truncate">
          <img
              src="@/assets/images/sidebar-icons/notifications-colored.svg"
              height="30"
              alt=""
          />
          <span class="text-primary mb-2 fsize-3 align-middle">
          Notifications
        </span>
        </div>
        <b-link to="Notifications" class="bg-primary py-1 px-3 rounded-pill text-white"
        ><b-icon icon="arrow-right"></b-icon
        ></b-link>
      </div>

      <div
        class="textBoxNotification"
        v-for="(notification, index) in notifications"
        :key="notification.id"
      >
        <div
          class="content ellipsis" v-ellipsis-directive speed="160"
          :class="{
            'text-primary font-weight-bold letter-spacing-3': index === 0,
          }"
        >
        <span>
          <span
            >{{
              moment(notification.creationDate, "x").format(
                "DD/MM/YYYY - HH:mm"
              )
            }}
            :
          </span>
          <span v-html="notification.content"> </span>
        </span>
        </div>
      </div>
    </div>
  </b-skeleton-wrapper>
</template>

<script>
import Vue from 'vue';
Vue.directive('ellipsis-directive', {
  inserted: (el, _binding, vnode) => {
    el.addEventListener(
      'mouseenter',
      function () {
        const speed = parseInt(el.getAttribute('speed'), 10);
        const length = el.firstChild.offsetWidth - el.offsetWidth;
        const time = length / speed;
        el.firstChild.style.transition = 'left ' + time + 's linear';
        el.firstChild.style.left = '-' + length + 'px';

      },
      false
    );
    el.addEventListener(
      'mouseleave',
      function () {
        el.firstChild.style.transition = 'left 0s linear';
        el.firstChild.style.left = '0px';
      },
      false
    );
  },
});

export default {
  name: 'NotificationCard',
  props: ['notifications', 'loading'],
};
</script>
